var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shangwushuju-layer"},[_c('caseheader'),_c('div',{staticClass:"sh-container"},[_c('iframe',{attrs:{"src":_vm.SWSJURL,"frameborder":"0","width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }